var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signal-display"},[_vm._t("icon"),_c('SignalIcon',{attrs:{"bars":_vm.score}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }